<!-- 屹诚销售订单模板 -->
<template>
    <div v-loading="loading">
        <div id="printYCSalesContent" class="print-zone">
            <div class="print-for" style="width: 763px; margin: 0 auto">
                <div id="top">
                    <div class="print-title-view">
                        <div v-if="isEditTitle" class="print-title">
                            <el-input type="text" style="width: 70%" v-model="titleConfig.RValue"></el-input>
                        </div>
                        <div v-else class="print-title">{{ orderData.IsHaveTitleSet ? orderData.OrderTitle : titleConfig.RValue }}</div>
                        <div class="print-title2">正厂钣金、灯具、保险杠不打木架坏了不负责</div>
                    </div>

                    <div class="print-orderDetail">
                        <div class="row">
                            <div class="col col-9 bold" style="height: auto; padding-right: 0px; padding-left: 0px; margin-left: 15px">
                                <label class="label_l">客户名称：</label>
                                <div class="grid-content cname">{{ orderData.EntpCusName }}</div>
                            </div>
                            <div class="col col-8">
                                <label class="label_l">支付方式：</label>
                                <div class="grid-content">{{ orderData.PayTypeName }}</div>
                            </div>
                            <!-- <div class="col col-6 barfa">
                                <div class="grid-content"><svg id="barcode" /></div>
                            </div> -->
                            <div class="col col-6 qcode1">
                                <div class="order-code">
                                    <canvas id="canvasDom" class="qrcode-canvas" ref="canva"></canvas>
                                    <img class="qrcode-image" :src="imgUrl" v-if="imgUrl" />
                                </div>
                                <div class="order-text">{{ orderData.OrderCode }}</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-9" style="height: auto; padding-right: 0px; padding-left: 0px; margin-left: 15px">
                                <label class="label_l">联系电话：</label>
                                <div class="grid-content cname">{{ orderData.PhoneNum }}</div>
                            </div>
                            <div :class="!isEditOpenTime ? 'col col-8' : 'autoWH'">
                                <label class="label_l">单据日期：</label>
                                <el-date-picker
                                    v-if="isEditOpenTime"
                                    v-model="orderData.CreateTime"
                                    value-format="yyyy-MM-dd HH:mm"
                                    type="datetime"
                                    size="small"
                                    placeholder="选择日期时间"
                                ></el-date-picker>
                                <div v-if="!isEditOpenTime" class="grid-content">{{ orderData.CreateTime }}</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-9 bold" style="height: auto; padding-right: 0px; padding-left: 0px; margin-left: 15px">
                                <label class="label_l">发货方式</label>
                                <div class="grid-content cname">{{ orderData.ShipTypeName }}</div>
                            </div>
                            <div class="col col-8 bold">
                                <label class="label_l">物流名称：</label>
                                <div class="grid-content">{{ orderData.LogisticName }}</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col rkCol bold-text2" style="height: auto; padding-right: 0px; padding-left: 0px; margin-left: 15px">
                                <label class="label_r">备注：</label>
                                <div class="grid-content cname">{{ orderData.Remark }}</div>
                            </div>
                            <div class="row MAnchor">
                                <div v-if="orderData.IsModified" class="isModif">改</div>
                                <div v-if="orderData.SaleNo" class="shipTypeCount shipTypetop">{{ orderData.SaleNo }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="table">
                    <table border="1" cellspacing="0" cellpadding="1" width="100%" style="border-collapse: collapse; table-layout: fixed" bordercolor="#333333">
                        <thead>
                            <tr style="font-weight: bold">
                                <td width="4%">
                                    <div><b>序</b></div>
                                </td>
                                <td width="21%">
                                    <div><b>编码</b></div>
                                </td>
                                <td width="18%">
                                    <div><b>名称</b></div>
                                </td>
                                <td width="13%">
                                    <div><b>车型</b></div>
                                </td>
                                <td width="5%">
                                    <div><b>单位</b></div>
                                </td>
                                <td width="6%">
                                    <div><b>数量</b></div>
                                </td>
                                <td width="8%">
                                    <div><b>产地</b></div>
                                </td>
                                <td width="6%">
                                    <div><b>单价</b></div>
                                </td>
                                <td width="8%">
                                    <div><b>金额</b></div>
                                </td>
                                <td width="11%">
                                    <div><b>仓位</b></div>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-bind:key="index" v-for="(AP, index) in orderData.DetailList">
                                <td>{{ Number(index) + 1 }}</td>
                                <td style="white-space: pre-wrap; word-wrap: break-word; word-break: break-all">{{ AP.APCode }}</td>
                                <td>{{ AP.GoodName }}</td>
                                <td>{{ AP.AutoSerise }}</td>
                                <td>{{ AP.Unit }}</td>
                                <td>{{ AP.Count }}</td>
                                <td>{{ AP.Origin }}</td>
                                <td>{{ AP.BillingPrice }}</td>
                                <td>{{ (AP.Count * AP.BillingPrice).toFixed(2) }}</td>
                                <td style="white-space: pre-wrap; word-wrap: break-word; word-break: break-all">{{ AP.GoodsLocation }}</td>
                            </tr>
                            <tr>
                                <td colspan="2" align="right">
                                    <div style="font-weight: bold; padding-right: 15px"><a>合计</a></div>
                                </td>
                                <td colspan="3" style="font-weight: bold; padding-left: 15px">{{ capitalAmount }}</td>
                                <td colspan="2">{{ allNum }}</td>
                                <td></td>
                                <td colspan="2">{{ allPrice }}</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div id="foot">
                    <!--    脚注    -->
                    <div
                        class="order-remark bold"
                        slot="content"
                        v-if="(config == null ? false : config.Result && !isEditConfig) || orderData.IsHaveTitleSet"
                        v-html="orderData.IsHaveTitleSet ? orderData.FootNote.replace(/\n/g, '<br/>') : config.RValue.replace(/\n/g, '<br/>')"
                    ></div>
                    <div class="order-setcontent" v-if="isEditConfig">
                        <el-input type="textarea" resize="auto" rows="3" v-model="config.RValue"></el-input>
                    </div>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <div class="btn-ctn-left">
                <div class="re-set">
                    <el-button
                        class="btn-primary"
                        @click="isEditTitle = true"
                        v-if="titleConfig == null ? false : titleConfig.Result && !isEditTitle && !orderData.IsHaveTitleSet"
                        >编辑标题</el-button
                    >
                    <el-button class="btn-primary" @click="submitTitleConfig()" v-if="isEditTitle">保存标题</el-button>
                </div>
                <!--   脚注   -->
                <div class="re-set">
                    <el-button class="btn-primary" @click="setConfig()" v-if="config == null ? false : config.Result && !isEditConfig && !orderData.IsHaveTitleSet"
                        >编辑脚注</el-button
                    >
                    <el-button class="btn-primary" @click="submitConfig()" v-if="isEditConfig">保存脚注</el-button>
                </div>
                <!--   开单时间   -->
                <div class="open-time">
                    <el-button class="btn-primary" @click="setOpenTime()" v-if="openTimeConfig && openTimeConfig.Result && !isEditOpenTime">设置开单时间</el-button>
                    <el-button class="btn-primary" @click="submitOpenTime()" v-if="isEditOpenTime">保存开单时间</el-button>
                </div>
                <div class="sort-set">
                    <el-button class="btn-primary" @click="setSortField('sortnum')">原始排序</el-button>
                    <el-button class="btn-primary" @click="setSortField('code')">编码排序</el-button>
                    <el-button class="btn-primary" @click="setSortField('shelfspace')">仓位排序</el-button>
                </div>
            </div>
            <div class="re-submit" v-if="!isEditConfig && !isEditTitle">
                <el-button class="btn-primary" @click="lodopPrint" :disabled="loading">打印</el-button>
                <el-button @click="cancel()" :disabled="loading">关闭</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import html2canvas from 'html2canvas';
import QRCode from 'qrcode';
import JsBarcode from 'jsbarcode';
export default {
    name: '',
    components: {},
    props: {
        isInit: {
            default: true,
            type: Boolean
        },
        printType: {
            type: Number,
            default: 0
        },
        printIds: {
            type: Array
        }
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            loading: true,
            orderData: {},
            userMsg: userMsg,
            allPrice: 0,
            allNum: 0,
            capitalAmount: '',
            isPrint: false,
            isPreview: false,
            isDefaultSet: false,
            company: userMsg.EntpName,
            isEditTitle: false, //编辑标题
            imgUrl:'',
            titleConfig: {
                RValue: userMsg.EntpName + '销售单'
            }, //标题配置
            openTimeConfig: null, // 开单时间配置
            isEditOpenTime: false, // 编辑开单时间
            config: null, // 脚注配置
            isEditConfig: false, // 编辑脚注
            sortField: 'sortnum' //排序
        };
    },
    watch: {
        // orderData(value) {
        //     if (!this.isInit) return;
        //     this.$nextTick(function () {
        //         JsBarcode('#barcode', value.OrderCode, {
        //             width: 1.1,
        //             height: 40,
        //             fontSize: 14,
        //             margin: 0,
        //             displayValue: true
        //         });
        //     });
        // }
    },
    created() {},
    mounted() {
        if (this.isInit) {
            this.init();
        } else this.loading = false;
    },
    methods: {
        init() {
            this.orderData = {};
            let sortField = this.$util.getLocalStorage('sale_print_' + this.userMsg.EmployeeId);
            if (sortField) this.sortField = sortField;
            this.getConfigByCodes().then(() => {
                this.getSaleOrder().then(resp => {
                    if (!this.isInit && resp) {
                        this.lodopPrint();
                        // this.$nextTick(() => {
                        //     setTimeout(() => {
                        //         this.lodopPrint();
                        //     }, 100);
                        // });
                    }
                });
            });
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['dyxssj', 'dyxs', 'dyshbt', 'dyyl', 'syllqdysz'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'dyxssj':
                                    this.openTimeConfig = data[i];
                                    break;
                                case 'dyxs':
                                    this.config = data[i];
                                    break;
                                case 'dyshbt':
                                    this.titleConfig = data[i];
                                    if (!this.titleConfig || !this.titleConfig.RValue) this.titleConfig.RValue = this.company + '销售单';
                                    break;
                                case 'dyyl':
                                    this.isPreview = result;
                                    break;
                                case 'syllqdysz':
                                    this.isDefaultSet = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        lodopPrint() {
            let LODOP = this.$lodop.getLodop(); //调用getLodop获取LODOP对象
            if (LODOP) {
                LODOP.PRINT_INIT('打印销售单');
                let topStyle = `
                    .print-title-view {
                        width: 790px;
                        position: relative;
                        justify-content: space-between;
                        align-items: flex-end;
                        padding: 0;
                    }
                    .print-title {
                        margin: 0 auto;
                        text-align: center;
                        font-size: 24px;
                        font-weight: bold;
                        color: #000;
                        min-height: 26px;
                    }
                    .print-title2 {
                        margin: 0 auto;
                        text-align: center;
                        font-size: 16px;
                        font-weight: bold;
                        color: #000;
                        min-height: 20px;
                        padding-bottom: 15px;
                    }
                    .cname {
                        overflow: hidden !important;
                        word-break: break-all !important;
                        word-wrap: break-word !important;
                        white-space: pre-wrap !important;
                        white-space: break-spaces !important;
                        width: 70%;
                    }  
                    .bold-text{
                        font-size: 16px;
                    }
                    .bold-text2{
                        font-size: 18px;
                    }                    
                    .print-orderDetail {
                        width: 762px;
                        margin-bottom: 10px;
                        font-size: 14px !important;
                        color: #000;
                        padding: 0;
                        padding-left: 5px;
                        margin-right: 20px;
                    }
                    .print-orderDetail .barfa{
                        display:none;
                    }
                    .print-orderDetail .row {
                        margin-left: -10px;
                        margin-right: -10px;
                        -webkit-box-sizing: border-box;
                        box-sizing: border-box;
                        margin-bottom: 5px;
                    }
                    .print-orderDetail .row:last-child{
                        margin-bottom: 0px;
                    }                    
                    .print-orderDetail .row::after,
                    .print-orderDetail .row::before {
                        display: table;
                        content: '';
                        clear: both;
                    }
                    .print-orderDetail .row .col {
                        float: left;
                        -webkit-box-sizing: border-box;
                        box-sizing: border-box;
                        padding-left: 10px;
                        padding-right: 10px;
                        line-height: 18px;
                        height: auto;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .print-orderDetail .col-5 {
                        width: 20.83333%;
                    }
                    .print-orderDetail .col-6 {
                        width: 25%;
                    }
                    .print-orderDetail .col-7 {
                        width: 29.16667%;
                    }
                    .print-orderDetail .col-8 {
                        width: 33.33333%
                    }
                    .print-orderDetail .col-9 {
                        width: 37.5%;
                    }   
                    .print-orderDetail .row .height40 {
                        height: 40px !important;
                    }

                    .print-orderDetail .row .col .label_l {
                        width: 70px;
                        text-align: left;
                        vertical-align: middle;
                        float: left;
                        line-height: 18px;
                    }
                    .print-orderDetail .row .col .label_r {
                        width: 70px;
                        text-align: right;
                        vertical-align: middle;
                        float: left;
                        line-height: 18px;
                    }
                    .print-orderDetail .row .col .grid-content {
                        display: inline-block;
                        min-height: 18px;
                        border-radius: unset;
                        line-height: 18px;
                    } 
                    .print-orderDetail .row .col .debts{
                        padding-top: 3px;
                    }
                    .print-orderDetail .row .col .grid-content::after,
                    .print-orderDetail .row .col .grid-content::before {
                        display: table;
                        content: '';
                        clear: both;
                    } 
                    .print-orderDetail .rkCol{
                        height: auto !important;
                        font-weight: bold;
                    }
                    .print-orderDetail .rkCol .grid-content{
                        overflow: hidden !important;
                        word-break: break-all !important;
                        word-wrap: break-word !important;
                        white-space: break-spaces !important;
                        white-space: pre-wrap !important;
                        width: 65% !important;
                    }
                    .isModif{
                        display: none;
                    }   
                    .order-code{
                        display: none;
                    }
                    .order-text{
                        display: none;
                    }
                    .bold{
                        font-size: 16px;
                        font-weight: bold;
                    }
               `;
                var tableStyle = `
                    table,
                    td,
                    th {
                        border-width: 1px;
                        border-style: solid;
                        border-collapse: collapse;
                        color: #000;
                        padding-bottom: 3px;
                        padding-top: 3px;
                        padding-left: 2px;                        
                    }
                    td{
                        white-space: nowrap;
                        text-overflow: clip;
                        overflow: hidden;   
                        vertical-align: top                     
                    }                     
                    table{
                        border-top: solid 1px black;
                        border-bottom: 0px;
                        border-left: 0px;
                        border-right: 0px;                       
                    }
                    tfoot td {
                        font-weight: bold;
                        border: 0;
                    }
                                     
                `;

                let footStyle = `
                    .order-remark {
                        width: 762px;
                        display: -webkit-flex;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        padding-top: 5px;
                        color: #000;
                        width: 100%;
                        margin: 0 auto;
                        font-size: 15px;
                    }    
                    .bold{
                        font-weight: bold;
                    }
                    .fwb {
                        font-weight: bold;
                    }
                    .btd {
                        border-bottom: 1px dashed #000;
                        font-weight: bold;
                    }                                
                `;
                LODOP.SET_PRINT_STYLEA(0, 'Horient', 2);
                let contentHeight = document.getElementById('printYCSalesContent').clientHeight;
                let topHeight = document.querySelector('#printYCSalesContent #top').clientHeight;
                let tableHeight = document.querySelector('#printYCSalesContent #table').clientHeight;
                let footHeight = document.querySelector('#printYCSalesContent #foot').clientHeight;
                let printTableH = 1080 - topHeight;

                if (this.orderData.IsModified) {
                    //画椭圆，因为打印插件不支持css的border-radius 所以这里用了他自身的画图像的接口
                    LODOP.ADD_PRINT_SHAPE(3, topHeight - 20, 658, 41, 27, 'solid', 2, 'black');
                    // LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1);
                    LODOP.ADD_PRINT_TEXT(topHeight - 15, 673, 41, 41, '改'); //增加纯文本项
                    // LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1);
                }

                if (this.orderData.SaleNo) {
                    //画椭圆，因为打印插件不支持css的border-radius 所以这里用了他自身的画图像的接口
                    LODOP.ADD_PRINT_SHAPE(3, topHeight - 20, 708, 41, 27, 'solid', 2, 'black');
                    // LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1);
                    //增加纯文本项
                    if (this.orderData.SaleNo < 10) LODOP.ADD_PRINT_TEXT(topHeight - 18, 723, 41, 41, this.orderData.SaleNo);
                    else LODOP.ADD_PRINT_TEXT(topHeight - 18, 719, 41, 41, this.orderData.SaleNo);
                    LODOP.SET_PRINT_STYLEA(0, 'FontSize', 16);
                    LODOP.SET_PRINT_STYLEA(0, 'Bold', 1);
                    // LODOP.SET_PRINT_STYLEA(0, 'ItemType', 1);
                }

                LODOP.SET_PRINT_PAGESIZE(1, "210mm", "150mm", "A5");


                // LODOP.ADD_PRINT_BARCODE(70, 500, 280, 50, '128Auto', this.orderData.OrderCode);               

                LODOP.ADD_PRINT_BARCODE(40, 600, 100, 100, 'QRCode', this.orderData.OrderCode);
                LODOP.SET_PRINT_STYLEA(0, 'QRCodeVersion', 3);
                LODOP.SET_PRINT_STYLEA(0, 'QRCodeErrorLevel', 'L');

                LODOP.ADD_PRINT_TEXT(130, 570, 200, 100, this.orderData.OrderCode);
                LODOP.SET_PRINT_STYLEA(0, 'FontSize', 12);
                LODOP.SET_PRINT_STYLEA(0, 'Bold', 1);

                LODOP.ADD_PRINT_HTM(
                    '0',
                    '0',
                    '98%',
                    '100%',
                    `<!DOCTYPE html><style>${topStyle}</style>` + document.querySelector('#printYCSalesContent #top').innerHTML
                );

                LODOP.ADD_PRINT_TABLE(
                    topHeight + 10,
                    0,
                    '98%',
                    'BottomMargin:5px',
                    `<style>${tableStyle}</style>` + document.querySelector('#printYCSalesContent #table').innerHTML
                );
                //次页开始的上边距偏移量
                LODOP.SET_PRINT_STYLEA(0, 'Offset2Top', -topHeight + 3);

                if (footHeight > 0) {
                    LODOP.ADD_PRINT_HTM('0', '0', '98%', footHeight, `<style>${footStyle}</style>` + document.querySelector('#printYCSalesContent #foot').innerHTML);
                    LODOP.SET_PRINT_STYLEA(0, 'LinkedItem', -1);
                }
                // //设计
                // LODOP.PRINT_DESIGN();
                //选择操作系统中设为“默认”的打印机，“-1”代表默认打印机
                LODOP.SET_PRINTER_INDEX(-1);

                // //预览
                if (this.isPreview) LODOP.PREVIEW();
                else LODOP.PRINT(); // 直接打印

                setTimeout(() => {
                    this.printedRecord();
                }, 1000);
            }
        },
        // 取消
        cancel() {
            this.$emit('closePrintDialog', this.isPrint); //这个是开单页面
            this.$emit('closeDialog', this.isPrint); //这个是列表页面
        },
        printedRecord() {
            this.loading = true;
            this.$util
                .printedRecord({ OrderId: this.printIds[0], Type: 0 }, false)
                .then(() => {
                    this.isPrint = true;
                    this.loading = false;
                    if (!this.isInit) this.$emit('closeDialog', true);
                    else if(this.printType==1){
                        this.$emit('closePrintDialog', this.isPrint); //这个是开单页面
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 获取表格数据
        getSaleOrder() {
            return new Promise(resolve => {
                this.loading = true;
                let that = this;
                this.$util
                    .axiosGet({
                        url: '/api/EntpSaleOrder/GetEntpCusSaleOrderPrint',
                        data: {
                            EntpCusOId: that.printIds[0],
                            SortField: that.sortField,
                            GetNo: true
                        },
                        hideLoading: that.isInit
                    })
                    .then(res => {
                        if (res.errcode != 0 || !res.data) {
                            this.$message.error('加载打印内容异常，请重新操作！');
                            that.$emit('closeDialog', true);
                            that.loading = false;
                            resolve(false);
                            return;
                        }
                        let _allNum = 0;
                        let _allPrice = 0;
                        let data = res.data;
                        that.orderData = res.data;
                        let DetailList = data.DetailList;
                        for (let i = 0; i < DetailList.length; i++) {
                            _allNum += Number(DetailList[i].Count);
                            _allPrice += DetailList[i].Count * DetailList[i].BillingPrice;
                        }
                        that.allNum = _allNum;
                        that.allPrice = _allPrice;
                        that.capitalAmount = that.$util.moneyToCapital(_allPrice);

                        if (that.isInit) that.loading = false;

                        if (!that.imgUrl) {
                            that.$nextTick(function () {
                                let canvas = document.getElementById('canvasDom');
                                QRCode.toCanvas(
                                    canvas,
                                    data.OrderCode,
                                    {
                                        width: 80,
                                        height: 80,
                                        margin: 0,
                                        scrollX: 0,
                                        scrollY: 0
                                    },
                                    function (error) {}
                                );

                                setTimeout(() => {
                                    html2canvas(canvas, {
                                        width: 80,
                                        height: 80,
                                        scrollX: 0,
                                        scrollY: 0
                                    }).then(canvasRes => {
                                        var imgData = canvasRes.toDataURL('image/png');
                                        that.imgUrl = imgData;
                                        canvas.style.display = 'none';
                                    });
                                }, 1000);
                            });
                        }
                        resolve(true);
                    })
                    .catch(err => {
                        console.log(err);
                        that.loading = false;
                        resolve(false);
                    });
            });
        },
        setOpenTime() {
            this.isEditOpenTime = true;
        },
        submitOpenTime() {
            this.isEditOpenTime = false;
        },
        //提交打印标题
        submitTitleConfig() {
            this.isEditTitle = false;
            this.$util.setSysConfigValue(this.titleConfig.ConfigId, this.titleConfig.RValue);
        },
        setConfig() {
            this.isEditConfig = true;
        },
        // 提交脚注
        submitConfig() {
            if (!this.config.RValue || !this.config.RValue.trim()) {
                this.$message.error('请输入脚注');
                return;
            }
            this.isEditConfig = false;
            this.$util.setSysConfigValue(this.config.ConfigId, this.config.RValue);
        },
        setSortField(field) {
            this.$util.setLocalStorage('sale_print_' + this.userMsg.EmployeeId, field);
            this.sortField = field;
            this.getSaleOrder();
        }
    }
};
</script>

<style lang="less" scoped media="print">
.print-title-view {
    width: 100%;
    position: relative;
    justify-content: space-between;
    align-items: flex-end;
    padding: 0;
}

.order-remark {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-top: 5px;
    color: #000;
}
.order-setcontent {
    padding: 0px 0px 15px 0px;
    color: #000;
}
.print-title {
    margin: 0 auto;
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    color: #000;
    min-height: 26px;
}
.print-title2 {
    margin: 0 auto;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    color: #000;
    min-height: 20px;
    padding-bottom: 15px;
}
.bold-text2{
    font-size: 18px;
}
.dialog-footer {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    // justify-content: end;
    justify-content: space-between;
    margin-top: 20px;
}
.re-submit {
    text-align: right;
}

.print-zone {
    width: 210mm;
    position: relative;
}

.print-table-main {
    width: 792px;
    font-size: 14px;

    .div-table-cell {
        overflow: hidden;
        // text-overflow: ellipsis;
        // white-space: nowrap;
        word-break: break-all;
        word-wrap: break-word;
        height: auto;
        // line-height: 30px;
        line-height: 25px;
        padding-left: 1px;
        border-top: 1px solid #000;
        border-right: 1px solid #000;
        border-bottom: 1px solid #000;
        color: #000;
    }
    .tableConten {
        .div-table-cell {
            // line-height: 14px;
            // padding-top: 3px;
            line-height: 14px;
            //上下垂直居中
            display: -webkit-box;
            -webkit-box-orient: horizontal;
            -webkit-box-align: center;
            padding-bottom: 5px;
            padding-top: 5px;
        }
    }
    .div-table-row {
        border-left: 1px solid #000;
    }
}
.btn-ctn-left {
    display: flex;
}
.fdzt {
    font-size: 14px;
}
.sort-set {
    margin-left: 10px;
    .btn-primary {
        background: #ff9900;
        color: white;
        margin-left: 0px;
    }
}
.fwb {
    font-weight: bold;
}
.btd {
    border-bottom: 1px dashed #000;
    font-weight: bold;
    font-size: 15px;
}

.print-orderDetail {
    margin-bottom: 10px;
    font-size: 14px;
    color: #000;
    .qrcode-canvas,
    .qrcode-image {
        width: 80px;
        height: 80px;
        display: inline-block;
        vertical-align: top;
    }
}
.print-orderDetail .row {
    margin-left: -10px;
    margin-right: -10px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin-bottom: 5px;
}
.print-orderDetail .row:last-child {
    margin-bottom: 0px;
}
.print-orderDetail .row::after,
.print-orderDetail .row::before {
    display: table;
    content: '';
    clear: both;
}

.print-orderDetail .row .col {
    float: left;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding-left: 10px;
    padding-right: 10px;
    line-height: 18px;
    height: 18px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.print-orderDetail .col-5 {
    width: 20.83333%;
}
.print-orderDetail .col-6 {
    width: 25%;
}
.print-orderDetail .col-7 {
    width: 29.16667%;
}
.print-orderDetail .col-8 {
    width: 33.33333%;
}
.print-orderDetail .col-9 {
    width: 37.5%;
}

.print-orderDetail .row .height40 {
    height: 40px !important;
}
.print-orderDetail .row .barfa {
    height: auto;
    position: absolute;
    right: 30px;
}
.print-orderDetail .row .qcode1 {
    height: auto;
    position: absolute;
    right: -15px;
    top: 40px;
}
.order-code{
    padding-left:30px;
}
.cname {
    overflow: hidden !important;
    word-break: break-all !important;
    word-wrap: break-word !important;
    white-space: pre-wrap !important;
    width: 70%;
}  
.print-orderDetail .row .col .label_l {
    width: 70px;
    text-align: left;
    vertical-align: middle;
    float: left;
    line-height: 18px;
}
.print-orderDetail .row .col .label_r {
    width: 70px;
    text-align: right;
    vertical-align: middle;
    float: left;
    line-height: 18px;
}

.print-orderDetail .row .col .grid-content {
    display: inline-block;
    min-height: 18px;
    line-height: 18px;
    border-radius: unset;
}
.print-orderDetail .row .col .debts {
    padding-top: 3px;
}
.print-orderDetail .row .col .grid-content::after,
.print-orderDetail .row .col .grid-content::before {
    display: table;
    content: '';
    clear: both;
}
.print-orderDetail .rkCol {
    height: auto !important;
    font-weight: bold;
}
.print-orderDetail .rkCol .grid-content {
    overflow: hidden !important;
    word-break: break-all !important;
    word-wrap: break-word !important;
    white-space: pre-wrap !important;
    white-space: break-spaces !important;
    width: 65% !important;
}
.autoWH {
    width: auto;
    height: auto;
}
.MAnchor {
    position: relative;
    padding-bottom: 10px;
}
.isModif {
    text-align: center;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
    -moz-border-radius: 50%;
    padding: 1px 8px;
    color: red;
    border: solid 2px red;
    position: absolute;
    right: 120px;
    bottom: 3px;
}
.shipTypeCount {
    text-align: center;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
    -moz-border-radius: 50%;
    padding: 1px 11px;
    color: red;
    border: solid 2px red;
    position: absolute;
    right: 70px;
    bottom: 3px;
}

table,
td,
th {
    border-width: 1px;
    border-style: solid;
    border-collapse: collapse;
    color: #000;
    padding-bottom: 3px;
    padding-top: 3px;
    padding-left: 2px;
}
td {
    white-space: nowrap;
    text-overflow: clip;
    overflow: hidden;
}
tfoot {
    display: none;
}
.bold {
    font-size: 16px;
    font-weight: bold;
}
</style>
